var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10.5523 10 11 10.4477 11 11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11C9 10.4477 9.44772 10 10 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6V5C16.5 3.34315 15.1569 2 13.5 2H10.5C8.84315 2 7.5 3.34315 7.5 5V6L3 6C2.44772 6 2 6.44772 2 7C2 7.55229 2.44772 8 3 8H4.05398L4.56939 17.2773C4.71659 19.9269 6.90802 22 9.56169 22H14.4382C17.0919 22 19.2833 19.9269 19.4305 17.2773L19.946 8H21C21.5523 8 22 7.55229 22 7C22 6.44772 21.5523 6 21 6L16.5 6ZM14.5 5C14.5 4.44772 14.0523 4 13.5 4H10.5C9.94772 4 9.5 4.44772 9.5 5V6H14.5V5ZM17.9429 8L6.05707 8L6.56631 17.1664C6.65463 18.7562 7.96949 20 9.56169 20H14.4382C16.0304 20 17.3453 18.7562 17.4336 17.1664L17.9429 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.eddb71da5053a16f1263a1e8a0bb5100.svg";
export { ForwardRef as ReactComponent };